import { REMOVE_CALLABLE_ASSOCIATION } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageRemoveCallableAssociation(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: REMOVE_CALLABLE_ASSOCIATION,
      data
    });
  }
}